import {Button, Tooltip} from '@mui/material';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import Box from '@mui/material/Box';
import {LoadingButton} from '@mui/lab';
import PropsType from 'prop-types';

const UploadButton = ({
  isLoading,
  functionToRun,
  disabled = false,
  uploadMessage = '',
  isUploadCompleted = false,
  hasFile = false,
  hasSuccessfulData = true,
}) => {
  return (
    <>
      <AppsHeader>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              ml: 'auto',
            }}
          >
            {isLoading ? (
              <LoadingButton
                loading
                variant='outlined'
                loadingPosition='start'
                startIcon={<></>}
              >
                {uploadMessage || 'Uploading...'}
              </LoadingButton>
            ) : (
              <Tooltip
                title={
                  !hasFile
                    ? 'Please select a file to upload'
                    : isUploadCompleted && hasSuccessfulData
                    ? 'Upload completed! Select a new file to upload again'
                    : isUploadCompleted && !hasSuccessfulData
                    ? 'Upload completed but no valid data found. Please fix validation errors and try again'
                    : disabled
                    ? 'Please fix file format errors before uploading'
                    : 'Upload your Excel file'
                }
                arrow
              >
                <span>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={functionToRun}
                    disabled={disabled}
                    sx={{
                      opacity: disabled ? 0.6 : 1,
                      backgroundColor: !hasFile
                        ? '#bdbdbd'
                        : isUploadCompleted && hasSuccessfulData
                        ? '#4caf50'
                        : isUploadCompleted && !hasSuccessfulData
                        ? '#ff9800'
                        : disabled
                        ? '#f44336'
                        : undefined,
                      color: 'white',
                      '&:hover': {
                        backgroundColor: !hasFile
                          ? '#bdbdbd'
                          : isUploadCompleted && hasSuccessfulData
                          ? '#4caf50'
                          : isUploadCompleted && !hasSuccessfulData
                          ? '#ff9800'
                          : disabled
                          ? '#f44336'
                          : undefined,
                      },
                    }}
                  >
                    {!hasFile
                      ? '📁 Select File First'
                      : isUploadCompleted && hasSuccessfulData
                      ? '✅ Upload Complete'
                      : isUploadCompleted && !hasSuccessfulData
                      ? '⚠️ No Valid Data'
                      : disabled
                      ? '❌ Fix File Format'
                      : '📤 Upload Files'}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Box>
        </Box>
      </AppsHeader>
    </>
  );
};

UploadButton.propTypes = {
  isLoading: PropsType.bool.isRequired,
  functionToRun: PropsType.func.isRequired,
  disabled: PropsType.bool,
  uploadMessage: PropsType.string,
  isUploadCompleted: PropsType.bool,
  hasFile: PropsType.bool,
  hasSuccessfulData: PropsType.bool,
};

export default UploadButton;
